/// <reference path="../../typings/browser.d.ts" />

namespace Application.Directives {
    'use strict';

    /**
     * Factory callback type
     */
    declare type AutofocusDirectiveFactoryCb = ($timeout: ng.ITimeoutService) => AutofocustDirective;

    export class AutofocustDirective implements ng.IDirective {
        public static $name: string = 'autofocus';

        public link: ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => void;
        public restrict: string = 'A';
        public transclude: boolean = false;
        public template: string = '';

        /**
         * Factory for the directive
         */
        public static Factory(): AutofocusDirectiveFactoryCb {
            let directive: AutofocusDirectiveFactoryCb = ($timeout: ng.ITimeoutService) => {
                return new AutofocustDirective($timeout);
            };
            directive.$inject = ['$timeout'];
            return directive;
        }

        /**
         * Constructor
         */
        constructor(private $timeout: ng.ITimeoutService) {

            AutofocustDirective.prototype.link = ($scope: ng.IScope, $element: JQuery, attrs: ng.IAttributes) => {
                $timeout(() => {
                    $($element).focus();
                }, 600);
            };
        }
    }
}